import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import { Button } from "@sw-sw/lib-ui";
import Logo from "../../../images/SW-Logo-White.svg";

const SalesRepresentativePage: React.FC = () => {
  let freeTrialUserData:any = localStorage.getItem('freeTrialUserData')
  let freeTrialUserParsedData = JSON.parse(freeTrialUserData)
  const contactInfo = {
    "Name": freeTrialUserParsedData ? freeTrialUserParsedData.name: '',
  }

  return (
    <div className="sales-representative__wrapper">
      <div className="sales-representative">
        <header>
          <div className="trial-started__logo-wrapper">
            <img src={Logo} alt='logo' />
          </div>
          <h3>Already a member? <a href={`${process.env.REACT_APP_LOGIN_URL}/login`}>Login</a></h3>
        </header>
        <div className="sales-representative__body">
          <div className="sales-representative__inner-box-wrapper">
            <div className="sales-representative__inner-box">
              <div className="sales-representative__check-icon">
                <FontAwesomeIcon 
                  icon={faCheckCircle} 
                  color="#48af98" size="lg" 
                  style={{ width: "100px", height: "100px" }}
                />
              </div>
              <h1>Thank You For Your Interest!</h1>
              <h3>Hello {contactInfo.Name}, thank you for you interest in SW2. A Sales Representative will be contacting you shortly to provide the best available pricing for your needs.</h3>
              <h4>Have questions in the meantime?</h4>
              <div className="sales-representative__action-buttons">
                <Button primary onClick={() => window.location.href="mailto:info@sw2.net"}>
                  Contact Support
                </Button>
                <button onClick={() => window.location.href="https://sw2.net/"}>
                  Visit Our Website
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SalesRepresentativePage;
